import { type ReactNode } from "react";
import { useUserStore } from "@/service/user";
import { Loader } from "@/shared/ui";

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const inited = useUserStore((state) => state.inited);

  // Пока MSAL разбирает возврат из Microsoft и идёт тихий обмен токена — лоадер, а не роуты:
  // иначе уже вошедший пользователь при F5 на мгновение видел бы экран логина.
  if (!inited) return <Loader fullPage />;

  return <>{children}</>;
};
